var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"receive"}},[_c('br'),_c('h5',{staticClass:"left bold"},[_vm._v("\n    รายการผลการทดสอบ\n  ")]),_c('br'),_c('br'),_c('report-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }